/*
 * @Author: Dom
 * @Date: 2022-06-21 10:23:04
 * @LastEditTime: 2022-06-23 18:01:32
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\account\accountquery\locales\en-US.ts
 */
export default {
    'page.account.accountquery.overview': 'Account overview',
    'page.account.accountquery.primaryAccountNumber': 'Primary account number',
    'page.account.accountquery.code': 'Customer code',
    'page.account.accountquery.date': 'Date of registration',
    'page.account.accountquery.type': 'Account type',
    'page.account.accountquery.account': 'Total account',
    'page.account.accountquery.cash': 'Total cash',
    'page.account.accountquery.credit': 'Total credit',
    'page.account.accountquery.frozen': 'Frozen amount',
    'page.account.accountquery.used': 'Total used',
    'page.account.accountquery.bills': 'Unpaid bills',
    'page.account.accountquery.deduction': 'No bill generated (deduction)',
    'page.account.accountquery.frozenD': 'No bill generated (frozen)',
    'page.account.accountquery.balance': 'Available balance',
    'page.account.accountquery.details': 'View logistics document expense details',
    'page.account.accountquery.cashBalance': 'Cash balance',
    'page.account.accountquery.limit': 'Credit limit',
    'page.account.accountquery.deductionDetails': 'Deduction details',
    'page.account.accountquery.inquiry': 'Bill inquiry',
    'page.account.accountquery.prepaid': 'Prepaid account',
    'page.account.accountquery.period': 'Accounting period account',
    'page.account.accountquery.viewRechargeDetails': 'View recharge details',
    'page.account.accountquery.viewFrozenDetails': 'View frozen details',
    'page.account.accountquery.search': 'Query',
    'page.account.accountquery.expense': 'Time of expense',
    'page.account.accountquery.datez': 'Bill generation date',
    'page.account.accountquery.billcode': 'Bill No',
    'page.account.accountquery.cycle': 'billing cycle',
    'page.account.accountquery.amount': 'Bill amount',
    'page.account.accountquery.currency': 'Currency',
    'page.account.accountquery.dueDate': 'Bill due date',
    'page.account.accountquery.status': 'Billing status',
    'page.account.accountquery.detailsZ': 'Billing details',
    'page.account.accountquery.waybillNo': 'Waybill No',
    'page.account.accountquery.weight': 'Actual weight (g)',
    'page.account.accountquery.volume': 'Volume weight (g)',
    'page.account.accountquery.volumeZ': 'Volume (cm)',
    'page.account.accountquery.billingWeight': 'Billing weight (g)',
    'page.account.accountquery.expenseType': 'Expense type',
    'page.account.accountquery.expenseProject': 'Expense items',
    'page.account.accountquery.deductionAmount': 'Deduction amount',
    'page.account.accountquery.products': 'Product name',
};
